import { InvoiceItem } from './types';

const parseBrl = (val: unknown): number => {
  if (typeof val === 'number') return val;
  return Number(String(val || 0).replace(/\./g, '').replace(',', '.') || 0);
};

const fmtBrl = (val: number): string =>
  val.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const round2 = (n: number): number => Math.round(n * 100) / 100;

// Mesmo rateio da emissão (ratearFrete): proporcional ao valor do item, resíduo na última linha.
const ratearFrete = (valores: number[], frete: number): number[] => {
  const total = valores.reduce((soma, v) => soma + v, 0);
  if (frete <= 0 || total <= 0) return valores.map(() => 0);
  let alocado = 0;
  return valores.map((v, idx) => {
    if (idx === valores.length - 1) return round2(frete - alocado);
    const parcela = round2(frete * (v / total));
    alocado += parcela;
    return parcela;
  });
};

// Prévia do rascunho: base do ICMS = (item + frete rateado) × % da base, como o gateway calcula.
export function icmsComFrete(items: InvoiceItem[], valorFrete: number): InvoiceItem[] {
  const valores = items.map((i) => parseBrl(i.vlTotal));
  const fretes = ratearFrete(valores, valorFrete);
  return items.map((item, idx) => {
    const aliquota = Number(item.aliqIcms) || 0;
    if (aliquota <= 0) return item;
    const percentualBase = item.percBaseIcms ?? 100;
    const base = round2((((valores[idx] ?? 0) + (fretes[idx] ?? 0)) * percentualBase) / 100);
    return { ...item, bcIcms: fmtBrl(base), vlIcms: fmtBrl(round2((base * aliquota) / 100)) };
  });
}
